import { useOutlet } from 'react-router-dom'

import { Dashboard } from '@/components/dashboard/Dashboard'

export function OrganizationRoute() {
  const subRoute = useOutlet()
  return <>{subRoute ? subRoute : <Dashboard />}</>
}
